import { onMounted, ref } from 'vue';
import { fetchLuggageLocation, type LuggageLocationResponse } from '@/entities/application/api/fetchLuggageLocation';
import { useRoute } from 'vue-router';

/**
 * 荷物ロケーション履歴取得のカスタムフック
 * @returns 荷物ロケーション履歴データとエラーメッセージ
 */
export const useFetchLuggageLocation = () => {
    const route = useRoute();
    const locationData = ref<LuggageLocationResponse>();
    const errorMessage = ref<string>();
    const isLoading = ref(true);

    const fetch = async () => {
        try {
            isLoading.value = true;
            locationData.value = await fetchLuggageLocation(route.params.applicationId as string);
        } catch (error) {
            errorMessage.value = (error as Error).message;
        } finally {
            isLoading.value = false;
        }
    };

    onMounted(fetch);

    return {
        locationData,
        errorMessage,
        isLoading,
        refresh: fetch,
    };
};
